import { Icon, InputAdornment, NativeSelect } from '@mui/material'
import React from 'react'

function CustomNativeSelect({ children, icon, handleSelect }) {
    return (
        <NativeSelect
            onChange={(e) => handleSelect(e)}
            disableUnderline
            startAdornment={
                <InputAdornment position="start">
                    <Icon className="text-primary-main">
                        {icon}
                </Icon>
                </InputAdornment>
            }
            fullWidth
        >
            {children}
        </NativeSelect>
    )
}

export default CustomNativeSelect